import { render, staticRenderFns } from "./PitchDayStartups.vue?vue&type=template&id=342a0f59&scoped=true"
import script from "./PitchDayStartups.vue?vue&type=script&lang=js"
export * from "./PitchDayStartups.vue?vue&type=script&lang=js"
import style0 from "./PitchDayStartups.vue?vue&type=style&index=0&id=342a0f59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342a0f59",
  null
  
)

export default component.exports